module.exports = __webpack_public_path__ + "static/media/7-5.926e8d4c.mp3";